/**
 * Product tile second image on hover - JS fallback when Liquid doesn't output
 * the second image (e.g. limited product data on collection pages)
 * Uses MutationObserver to handle dynamically injected content (filters/sort)
 */
(function () {
  var fetchedHandles = {};

  function fetchAndShow(container) {
    var handle = container.dataset.productSecondImageHandle;
    if (!handle || fetchedHandles[handle]) return;

    var sizes = container.dataset.sizes || '100vw';

    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var images = data.product && data.product.images;
        if (!images || images.length < 2) return;

        fetchedHandles[handle] = true;

        var img = document.createElement('img');
        var imgSrc = images[1].src;
        img.src = imgSrc.indexOf('?') > -1 ? imgSrc + '&width=1440' : imgSrc + '?width=1440';
        img.alt = images[1].alt || data.product.title;
        img.loading = 'eager';
        img.className = 'block absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-200 ease-in-out product-tile-second-image z-[1]';
        if (sizes) img.sizes = sizes;
        container.appendChild(img);
      })
      .catch(function () {});
  }

  function setupContainer(container) {
    if (container.dataset.secondImageSetup) return;
    if (container.querySelector('img')) return;

    var card = container.closest('.group');
    if (!card || !container.dataset.productSecondImageHandle) return;

    container.dataset.secondImageSetup = '1';
    card.addEventListener('mouseenter', function () {
      fetchAndShow(container);
    });
  }

  function init() {
    document.querySelectorAll('[data-product-second-image-handle]').forEach(setupContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.addedNodes.length) {
            m.addedNodes.forEach(function (node) {
              if (node.nodeType === 1) {
                if (node.matches && node.matches('[data-product-second-image-handle]')) {
                  setupContainer(node);
                }
                var containers = node.querySelectorAll && node.querySelectorAll('[data-product-second-image-handle]');
                if (containers) containers.forEach(setupContainer);
              }
            });
          }
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    init();
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.addedNodes.length) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              if (node.matches && node.matches('[data-product-second-image-handle]')) {
                setupContainer(node);
              }
              var containers = node.querySelectorAll && node.querySelectorAll('[data-product-second-image-handle]');
              if (containers) containers.forEach(setupContainer);
            }
          });
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', init);
})();
